var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "span",
    [
      _c("w-select", {
        ref: "select",
        attrs: {
          label: _vm.label,
          fancy: _vm.fancy,
          light: _vm.light,
          items: _vm.items,
          value: _vm.selectedValue,
          disabled: _vm.disabled,
        },
        on: {
          input: function ($event) {
            return _vm.onInput($event)
          },
          keyup: function ($event) {
            return _vm.onKeyUp($event)
          },
        },
      }),
      _vm.createNewEnabled && _vm.toEditVat != null
        ? _c(
            "w-modal",
            { attrs: { value: "" } },
            [
              _c("app-vat-edit-modal", {
                attrs: { value: _vm.toEditVat },
                on: {
                  input: function ($event) {
                    return _vm.onVatCreated($event)
                  },
                  close: function ($event) {
                    _vm.toEditVat = null
                  },
                },
              }),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }